// AC-13 — the Pipelines list's client-side search, extracted to a pure function so it is
// unit-testable in isolation (per the deploy-pipelines-list-payload spec's testability
// note). Matching semantics are unchanged from the pre-payload implementation: a matching
// App Instance name keeps ALL its pipelines; otherwise a row is kept only if its own
// pipeline name / source image / target container name matches. All four fields are now
// payload-sourced (AppInstanceName / ContainerAppName come straight off
// GET /api/pipelines) rather than client-resolved lookup maps — the source moved, the
// matching behaviour did not.
export const filterPipelineRowsBySearch = (rows = [], searchTerm = '') => {
  const term = (searchTerm ?? '').trim().toLowerCase();
  if (!term) return rows ?? [];

  return (rows ?? []).filter(row => {
    const appInstanceMatches = (row?.AppInstanceName ?? '').toLowerCase().includes(term);
    return (
      appInstanceMatches ||
      (row?.Name ?? '').toLowerCase().includes(term) ||
      (row?.ImageName ?? '').toLowerCase().includes(term) ||
      (row?.ContainerAppName ?? '').toLowerCase().includes(term)
    );
  });
};

export default filterPipelineRowsBySearch;
